import { numbers } from '@glt-npm/numbers'

import errorHandler from '../../../legacyGameAndAdmin/Helpers/errorHandler'
import { getConsentsCookie } from '../../components/Cookie/utils'
import { analyticsInit, createFunctionWithTimeout, gtag } from '../Analytics/utils'
import { GoogleTagCategory, ErrorObject } from './types'

function sendGoogleTagEvent(
  action: string,
  eventCategory: GoogleTagCategory | string,
  params?: Record<string, any>,
): Promise<void> {
  const { statistical } = getConsentsCookie()

  analyticsInit(statistical)

  return new Promise((resolve) => {
    const { gTagAnalyticsEnabled } = window as any

    if (gTagAnalyticsEnabled && statistical) {
      gtag('event', `<${action}>`, {
        event_category: `<${eventCategory}>`,
        event_callback: createFunctionWithTimeout(() => resolve()),
        ...params,
      })
    } else {
      resolve()
    }
  })
}

export function sendEvent(category: GoogleTagCategory | string, action: string, label?: string, addPath?: string) {
  if ((window as any).DEBUG) {
    // eslint-disable-next-line no-param-reassign
    category = `${category}_dev`
  }

  if (addPath) {
    // eslint-disable-next-line no-param-reassign
    label += `[${document.location.pathname}]`
  }

  sendGoogleTagEvent(action, category, { label })
}

export function sendError(code: number, msg: string, customCategory?: string) {
  const category = customCategory || GoogleTagCategory.Error
  const err = errorHandler.getErrorByCode(code, '') as ErrorObject

  if (err.msg === errorHandler.defaultErrorMsg && msg) {
    err.msg = msg
  }

  sendGoogleTagEvent(`${err.type} [${err.code}]`, category, { label: err.msg })
}

export function sendInfo(type: string, label?: string) {
  sendGoogleTagEvent(type, GoogleTagCategory.Info, { label })
}

export function sendTimeStamp(action: string, _: any, timeDelay?: any) {
  const timeRange = numbers.timeToString(timeDelay)

  sendGoogleTagEvent(action, GoogleTagCategory.Time, { label: timeRange })
}
